<div class="body-wrapper"
     data-automation-e2e-selector="marketDrawerBody">
    <muni-gameday-market-drawer-markets *ngIf="!(fullscreen | async)" data-automation-e2e-selector="marketsBody">
    </muni-gameday-market-drawer-markets>
    <muni-gameday-market-drawer-ust *ngIf="!(fullscreen | async)" data-automation-e2e-selector="ustBody">
    </muni-gameday-market-drawer-ust>
    <muni-gameday-market-drawer-mmd *ngIf="!(fullscreen | async)" data-automation-e2e-selector="mmdBody">
    </muni-gameday-market-drawer-mmd>
    <muni-gameday-market-drawer-calendar [style.width]="((fullscreen | async) ? 100 : 40) + '%'" data-automation-e2e-selector="calendarBody">
    </muni-gameday-market-drawer-calendar>
</div>